import fetch from 'isomorphic-fetch';

import {
    convertirMomentATextEnUTC,
    MASCARA_YYYYMMDD
} from '../commons/gestioDates';
import obtenirConfiguracio from '../configuracioEntorns';
import { obtenirToken } from './gestioWebToken';

var configuracio = obtenirConfiguracio();
const API_SERVER_URL = configuracio.API_SERVER_URL + '/api';
const LOGIN_SERVER_URL = configuracio.API_SERVER_URL + '/login';

const ESTACIONS_URL = '/estacions';
const OBSERVACIONS_URL = '/observacions';
const OBSERVACIONS_EXPORTACIO_URL = '/observacions/exportacio';
const ESTACIONS_ACTIVES_PERIODE_EXPORTACIO_URL = '/observacions/exportacio/estacionsActivesPeriode';
const AVISOS_URL = '/avisos';
const DATA_ACTUAL_URL = '/data';
const MUNICIPIS_URL = '/municipis';
const USUARIS_URL = '/usuaris';
const TOKEN_URL = '/token';

const generarObjecteRespostaAmbStatusCode = (status, respostaServidor) => ({ status, body: respostaServidor });

const realitzarConsultaServidor = (url, parametresAEnviar) => {

    return fetch(url, parametresAEnviar)
        .then(response => {

            let resposta;

            if (response.ok) {
                resposta = response.json()
                    .then(resposta => generarObjecteRespostaAmbStatusCode(response.status, resposta));
            } else {
                resposta = response.json()
                    .then(resposta => {
                        const contigutError = generarObjecteRespostaAmbStatusCode(response.status, resposta);
                        return Promise.reject(contigutError);
                    });
            }

            return resposta;
        },
        () => {
            const missatgeError = 'Error realitzant la petició a servidor';
            throw missatgeError;
        });

};

const realitzarConsultaServidorApi = (url, parametresAEnviar, enviarStatusCodeExit = false) => {

    let parametresAmbToken = {...parametresAEnviar};
    const webToken = obtenirToken();

    if (webToken) {
        parametresAmbToken.headers = {...parametresAmbToken.headers, 'Authorization':`Bearer ${webToken}`};
    }

    return realitzarConsultaServidor(url, parametresAmbToken)
        .then(resposta => {
            if (enviarStatusCodeExit) {
                return resposta;
            }

            return resposta.body;
        });
};

/**
 * Es fa petició per modificar la contrasenya
 * @param {Number} idEstacioSeleccionada
 * @param {String} contrasenyaActual
 * @param {String} contrasenyaNova
 * @returns {*}
 */
export const fetchModificarContrasenya = (idUsuari, contrasenyaActual, contrasenyaNova) => {

    const parametresAEnviar = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ contrasenyaActual, contrasenyaNova })
    };

    const url = `${API_SERVER_URL}${USUARIS_URL}/${idUsuari}/contrasenya`;
    return realitzarConsultaServidorApi(url, parametresAEnviar);
};

/**
 * Consulta a servidor l'estructura del formulari per crear una estació
 * @returns {*}
 */
export const fetchEstacioIntroduccioEstructura = () => {
    const url = `${API_SERVER_URL}${ESTACIONS_URL}/introduccio`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Consulta a servidor l'estructura i les del formulari pel detall i l'edició d'una estació
 * @param idEstacioSeleccionada
 * @returns {*}
 */
export const fetchEstacioIntroduccioEstructuraIDades = (idEstacioSeleccionada) => {
    const url = `${API_SERVER_URL}${ESTACIONS_URL}/${idEstacioSeleccionada}`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Petició per crear una estació (inclou fotos)
 * @returns {*}
 */
export const fetchEstacioIntroduccioCrearEstacio = (dadesAEnviar) => {
    const parametresAEnviar = {
        method: 'POST',
        body: dadesAEnviar
    };

    const url = `${API_SERVER_URL}${ESTACIONS_URL}`;
    return realitzarConsultaServidorApi(url, parametresAEnviar, true);
};

/**
 * Petició per editar una estació (inclou fotos)
 * @param idEstacioSeleccionada
 * @returns {*}
 */
export const fetchEstacioIntroduccioEditarEstacio = (idEstacioSeleccionada, dadesAEnviar) => {
    const parametresAEnviar = {
        method: 'PUT',
        body: dadesAEnviar
    };

    const url = `${API_SERVER_URL}${ESTACIONS_URL}/${idEstacioSeleccionada}`;
    return realitzarConsultaServidorApi(url, parametresAEnviar, true);
};

export const fetchInserirComentari = (dadesAEnviar) => {

    const parametresAEnviar = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dadesAEnviar)
    };

    const url = `${API_SERVER_URL}${AVISOS_URL}/comentaris`;
    return realitzarConsultaServidorApi(url, parametresAEnviar, true);
};

/**
 * Consulta a servidor les estacions actives associades a un usuari en una data concreta.
 *
 * @param idUsuari
 * @param idRolUsuari
 * @param dataConsulta {Moment}
 * @returns {*}
 */
export const fetchEstacionsActives = (dataConsulta) => {
    const dataAstext = dataConsulta.format(MASCARA_YYYYMMDD);
    const url = `${API_SERVER_URL}${ESTACIONS_URL}/actives?dataConsulta=${dataAstext}`;
    return realitzarConsultaServidorApi(url);
};

//Consulta a servidor el formulari d'introducció i edició d'observacions per un dia, estacio i moment concrets
/**
 *
 * @param codiEstacio
 * @param codiMoment
 * @param dataConsulta {Moment}
 * @returns {*}
 */
export const fetchObservacionsVariablesFormulari = (codiEstacio, codiMoment, dataConsulta) => {
    const dataAstext = dataConsulta.format(MASCARA_YYYYMMDD);
    const url = `${API_SERVER_URL}${OBSERVACIONS_URL}/introduccio/estacions/${codiEstacio}/moments/${codiMoment}?dataConsulta=${dataAstext}`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Consulta a servidor totes les observacions per la data seleccionada
 * @param dataSeleccionada {Moment}
 * @returns {*}
 */
export const fetchObservacionsMapa = (dataSeleccionada) => {
    const dataAsText = dataSeleccionada.format(MASCARA_YYYYMMDD);
    const url = `${API_SERVER_URL}${OBSERVACIONS_URL}?dataConsulta=${encodeURIComponent(dataAsText)}`;
    return realitzarConsultaServidorApi(url);
};

//Consulta a servidor els estats de les observacions d'una estació
export const fetchEstats = (codiEstacio) => {
    const url = `${API_SERVER_URL}${OBSERVACIONS_URL}/estats/${codiEstacio}`;
    return realitzarConsultaServidorApi(url);
};


/**
 * Fa una petició al servidor per recuperar els avisos per un periode
 *
 * @returns {*}
 */
export const fetchObtenirAvisos = (dataInici, dataFi) => {
    const dataIniciText = convertirMomentATextEnUTC(dataInici);
    const dataFiText = convertirMomentATextEnUTC(dataFi);
    const url = `${API_SERVER_URL}${AVISOS_URL}?dataInici=${encodeURIComponent(dataIniciText)}&dataFi=${encodeURIComponent(dataFiText)}`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Fa una petició al servidor per recuperar els avisos de les últimes 24h
 *
 * @returns {*}
 */
export const fetchObtenirAvisosUltimes24h = () => {
    const url = `${API_SERVER_URL}${AVISOS_URL}/ultimes/24h`;
    return realitzarConsultaServidorApi(url);
};

export const fetchObservacioFormulariEnviar = (dadesAEnviar) => {

    const parametresAEnviar = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dadesAEnviar)
    };

    const url = `${API_SERVER_URL}${OBSERVACIONS_URL}/introduccio`;
    return realitzarConsultaServidorApi(url, parametresAEnviar);
};

/**
 * Consulta a servidor totes les observacions d'una determinada exportació per la data inici i la data fi
 * @param dataInici {Moment}
 * @param dataFi {Moment}
 * @returns {*}
 */
export const fetchExportacioObservacions = (dataInici, dataFi, idEstacio) => {
    const dataIniciAsText = convertirMomentATextEnUTC(dataInici, MASCARA_YYYYMMDD);
    const dataFiAsText = convertirMomentATextEnUTC(dataFi, MASCARA_YYYYMMDD);
    const estacio = (idEstacio !== undefined && idEstacio !== null) ? "&idEstacio=" + idEstacio : "";
    const url = `${API_SERVER_URL}${OBSERVACIONS_EXPORTACIO_URL}?dataInici=${dataIniciAsText}&dataFi=${dataFiAsText}${estacio}`;
    return realitzarConsultaServidorApi(url);
};


/**
 * Consulta a servidor totes les estacions actives per a la exportació per la data inici i la data fi
 * @param dataInici {Moment}
 * @param dataFi {Moment}
 * @returns {*}
 */
export const fetchEstacionsActivesPeriode = (dataInici, dataFi) => {
    const dataIniciAsText = convertirMomentATextEnUTC(dataInici, MASCARA_YYYYMMDD);
    const dataFiAsText = convertirMomentATextEnUTC(dataFi, MASCARA_YYYYMMDD);
    const url = `${API_SERVER_URL}${ESTACIONS_ACTIVES_PERIODE_EXPORTACIO_URL}?dataInici=${dataIniciAsText}&dataFi=${dataFiAsText}`;
    return realitzarConsultaServidorApi(url);
};

/**
 * AVISOS
 */

/**
 * Consulta a servidor els meteors pel formulari d'avisos, disponibles per la data seleccionada
 * @param dataSeleccionada {Moment}
 * @returns {*}
 */
export const fetchAvisosFormulariMeteors = () => {
    const url = `${API_SERVER_URL}${AVISOS_URL}/meteors`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Consulta a servidor el llistat de municipis
 * @returns {*}
 */
export const fetchAvisosMunicipis = () => {
    const url = `${API_SERVER_URL}${MUNICIPIS_URL}`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Realitzar el fetch per editar un avis.
 * @param avis {Object}, idAvis {Integer}
 * @returns Promise
 */
export const fetchEditarAvis = (avis, idAvis) => {
    const parametresAEnviar = {
        method: 'PUT',
        body: avis
    };

    const url = `${API_SERVER_URL}${AVISOS_URL}/${idAvis}`;
    const enviarStatusCode = true;
    return realitzarConsultaServidorApi(url, parametresAEnviar, enviarStatusCode);
};

/**
 * Realitzar el fetch per in        sertar un avis.
 * @param avis {Object}
 * @returns Promise
 */
export const fetchAvisFormulariEnviar = (avis) => {
    const parametresAEnviar = {
        method: 'POST',
        body: avis
    };

    const url = `${API_SERVER_URL}${AVISOS_URL}`;
    const enviarStatusCode = true;
    return realitzarConsultaServidorApi(url, parametresAEnviar, enviarStatusCode);
};

/**
 * Fa una petició al servidor per recuperar la data actual del servidor.
 *
 * @returns {*}
 */
export const fetchObtenirDataActual = () => {
    const url = `${API_SERVER_URL}${DATA_ACTUAL_URL}/actual`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Consulta a servidor els comentaris de visualitzacio d'avisos
 * @returns {*}
 */
export const fetchAvisComentaris = () => {
    const url = `${API_SERVER_URL}${AVISOS_URL}/comentaris`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Fa una petició al servidor per obtenir la data de l'ultima tile que s'ha generat pel producte de radar.
 */
export const fetchObtenirUltimaDataRadar = () => {
    const url = `${API_SERVER_URL}${DATA_ACTUAL_URL}/ultimaTileRadar`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Consulta a servidor per eliminar un comentari d'avisos
 * @returns {*}
 */
export const fetchAvisEliminarComentari = (idComentari) => {
    const parametresAEnviar = {
        method: 'DELETE'
    };

    const url = `${API_SERVER_URL}${AVISOS_URL}/comentaris/${idComentari}`;
    return realitzarConsultaServidorApi(url, parametresAEnviar);
};

/**
 * Elimina l'avís amb l'idAvis especificat
 * @returns {*}
 */
export const fetchAvisEliminar = (idAvis) => {
    const parametresAEnviar = {
        method: 'DELETE'
    };
    const url = `${API_SERVER_URL}${AVISOS_URL}/${idAvis}`;
    return realitzarConsultaServidorApi(url, parametresAEnviar);
};


export const fetchUsuaris = () => {

    const url = `${API_SERVER_URL}${USUARIS_URL}`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Consulta a servidor el llistat d'estacions
 * @returns {*}
 */
export const fetchObtenirEstacions = () => {
    const url = `${API_SERVER_URL}${ESTACIONS_URL}`;
    return realitzarConsultaServidorApi(url);
};


/**
 * Dona de baixa l'estació amb la id i la data de baixa especificada
 * @param {Integer} idEstacio
 * @param {Moment} dataBaixa
 * @returns {*}
 */
export const fetchDonarDeBaixaEstacio = (idEstacio, dataBaixa) => {
    const dataBaixaText = dataBaixa.format(MASCARA_YYYYMMDD);
    const parametresAEnviar = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({dataBaixa: dataBaixaText})
    };

    const url = `${API_SERVER_URL}${ESTACIONS_URL}/${idEstacio}`;
    return realitzarConsultaServidorApi(url, parametresAEnviar);
};

/**
 * Es fa la petició per a registrar-se a l'aplicació amb els diferents camps del formulari de login
 * @param {Object} valorsFormulariLogin
 * @returns {*}
 */
export const fetchLogin = (valorsFormulariLogin) => {

    const parametresAEnviar = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(valorsFormulariLogin)
    };

    const url = `${LOGIN_SERVER_URL}`;
    return realitzarConsultaServidor(url, parametresAEnviar)
        .then(resposta => resposta.body);
};

/**
 * Es fa la petició per a registrar-se a l'aplicació amb el token guardat al localStorage
 * @param {Object} token
 * @returns {*}
 */
export const fetchLoginAmbToken = () => {
    const url = `${API_SERVER_URL}${TOKEN_URL}`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Es fa la petició per a obtenir el llistat de rols d'usuari
 * @returns {*}
 */
export const fetchRols = () => {
    const url = `${API_SERVER_URL}${USUARIS_URL}/rols`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Es fa la petició per a obtenir les dades d'un usuari
 * @param {idUsuari} String
 * @returns {*}
 */
export const fetchDadesUsuari = idUsuari => {
    const url = `${API_SERVER_URL}${USUARIS_URL}/${idUsuari}`;
    return realitzarConsultaServidorApi(url);
};

/**
 * Es fa la petició per a restablir la contrasenya d\'un usuari
 * @param {idUsuari} String
 * @returns {*}
 */
export const fetchUsuariDonarDeBaixa = idUsuari => {
    const url = `${API_SERVER_URL}${USUARIS_URL}/${idUsuari}/baixa`;
    const parametresAEnviar = {
        method: 'PUT'
    };
    return realitzarConsultaServidorApi(url, parametresAEnviar, true);
};

export const fetchUsuariIntroduccioCrearUsuari = valors => {

    const parametresAEnviar = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(valors)
    };

    const url = `${API_SERVER_URL}${USUARIS_URL}`;
    return realitzarConsultaServidorApi(url, parametresAEnviar);
};

export const fetchUsuariIntroduccioEditarUsuari = (idUsuari, valors) => {

    const parametresAEnviar = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(valors)
    };

    const url = `${API_SERVER_URL}${USUARIS_URL}/${idUsuari}`;
    return realitzarConsultaServidorApi(url, parametresAEnviar);
};

/**
 * Es fa la petició per a donar d'alta un usuari
 * @param {Object} idUsuari
 * @returns {*}
 */
export const fetchUsuariDonarDeAlta = idUsuari => {
    const url = `${API_SERVER_URL}${USUARIS_URL}/${idUsuari}/alta`;
    const parametresAEnviar = {
        method: 'PUT'
    };
    return realitzarConsultaServidorApi(url, parametresAEnviar, true);
};


/**
 * Es fa la petició per a restablir la contrasenya d\'un usuari
 * @param {Object} idUsuari
 * @returns {*}
 */
export const fetchUsuariRestablirContrasenya = idUsuari => {
    const url = `${API_SERVER_URL}${USUARIS_URL}/${idUsuari}/contrasenya/restablir`;
    const parametresAEnviar = {
        method: 'PUT'
    };
    return realitzarConsultaServidorApi(url, parametresAEnviar);
};



// WEBPACK FOOTER //
// ./src/commons/consultesServidor.js